export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const analytics = useAnalytics()

  let initialized = false
  let previousAnalyticsPath = ''

  async function trackInitialPage() {
    if (!analytics.enabled || initialized) return

    await nextTick()

    const route = router.currentRoute.value
    const currentPath = analytics.normalizePath(route.path)

    previousAnalyticsPath = currentPath

    analytics.trackPage(currentPath)

    initialized = true
  }

  nuxtApp.hook('app:mounted', () => {
    void trackInitialPage()
  })

  router.afterEach(async (to, from, failure) => {
    const navigationSource = consumeAnalyticsNavigationSource()

    if (failure || !analytics.enabled || !initialized) return

    /*
     * Les changements de query string ou de fragment ne constituent pas une
     * nouvelle page Analytics Morning.
     *
     * Exemples :
     * /todos?list=...
     * /todos?view=...
     *
     * Ils seront instrumentés plus tard comme interactions fonctionnelles.
     */
    if (to.path === from.path) return

    const targetFullPath = to.fullPath

    await nextTick()

    /*
     * Une seconde navigation a pu avoir lieu pendant le tick Vue.
     * Dans ce cas, on n'envoie pas un état intermédiaire obsolète.
     */
    if (router.currentRoute.value.fullPath !== targetFullPath) return

    const destination = analytics.normalizePath(to.path)
    const origin = previousAnalyticsPath || analytics.normalizePath(from.path)

    analytics.trackEvent(
      'navigation_transition',
      {
        from: origin,
        to: destination,
        source: navigationSource,
      },
      destination,
    )

    analytics.trackPage(destination)

    previousAnalyticsPath = destination
  })
})
